__turbopack_context__.v({
  "className": "C_wZNW_className",
});
